import React from "react";
import { Button, CircularProgress } from "@mui/material";

const ButtonContained = ({
    text,
    height,
    width,
    marginRight,
    marginLeft,
    borderRadius,
    endIcon,
    startIcon,
    onClick,
    marginTop,
    marginBottom,
    color,
    disabled,
    type,
    loading,
    disableLoader,
    fontWeight,
    href,
    fontSize,
    padding,
    fullWidth,
    backgroundColor,
    lineHeight,
    minWidth,
    sx
}) => {
    return (
        <Button
            type={type}
            variant="contained"
            // color={color === "error" ? "error" : "primary"}
            sx={{
                color: color || "#FFFFFF",
                backgroundColor: backgroundColor || "#3E4095",
                ":hover": {
                    backgroundColor: backgroundColor || "#3E4095",
                },
                borderRadius: borderRadius || "8px",
                marginTop: marginTop,
                marginBottom: marginBottom,
                height: height || "35px",
                width: width || "auto",
                marginRight: marginRight,
                marginLeft: marginLeft,
                fontSize: fontSize || "12px",
                fontWeight: fontWeight || 500,
                padding: padding || "10px 12px 12px 10px",
                lineHeight: lineHeight || "24px",
                minWidth: minWidth,
                ...sx
            }}
            disableElevation
            startIcon={startIcon}
            endIcon={endIcon}
            onClick={onClick}
            disabled={disabled}
            href={href}
            fullWidth={fullWidth}
        >
            {text}
            {
                loading && !disableLoader ? (
                    <CircularProgress size={20} color={"inherit"} sx={{ marginLeft: 3 }} />
                ) : (
                    ""
                )
            }
        </Button >
    );
};

export default ButtonContained;
